import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {FileSpreadsheet} from 'lucide-react';
import {hideAppLoader} from '@/matic/lib/utils/hide-app-loader';
import {QuotesHeaderBar} from './QuotesHeaderBar';

/**
 * What `/quotes/*` shows when the tenant has no quoting engine, or when a page belongs
 * to a workspace this tenant doesn't use. A designed "can't act" empty: it says why and
 * offers no create action, since quoting is set up per tenant, not by the user.
 */
export function QuotingUnavailable() {
  // `/quotes` is chromeless: the page dismisses the boot overlay itself.
  useEffect(() => {
    hideAppLoader();
  }, []);

  return (
    <div className="flex h-full min-h-0 flex-col bg-neutral-50">
      <QuotesHeaderBar />
      <div className="flex flex-1 items-center justify-center p-8">
        <div className="flex max-w-sm flex-col items-center gap-2 text-center">
          <FileSpreadsheet className="h-8 w-8 text-neutral-400" aria-hidden />
          <h2 className="text-base font-semibold text-neutral-900">
            Quoting isn’t set up for your workspace
          </h2>
          <p className="text-sm text-neutral-500">
            Ask your administrator to connect a quoting engine for your tenant.
          </p>
          <Link
            to="/home"
            className="mt-2 text-sm font-medium text-neutral-700 underline-offset-2 hover:underline"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
